module.exports = __webpack_public_path__ + "static/media/layout4-img.ec72357e.svg";